import env from '../env';

export default {
	POST_USER_SETTINGS: `${env.API_INVENTORY}Virtuoso/UserSettings`,
	GET_USER_SETTINGS: `${env.API_VIEWER}Virtuoso/UserSettings`,
	POST_FEEDBACK: `${env.API_INVENTORY}Virtuoso/Feedback`,
	USER: `${env.API_ACCOUNT}User/GetUserCustomerDetailsForLogin`,
};
